import { Field } from 'formik'
import React, { useEffect, useState } from 'react'

import TextField from 'components/Common/TextField'
import { IconButton } from '@mui/material'

import VisibilityOutlinedIcon from '@mui/icons-material/VisibilityOutlined';
import VisibilityOffOutlinedIcon from '@mui/icons-material/VisibilityOffOutlined';


const FormikTextField = props => {
  const [isPasswordField, setIsPassword] = useState(false)
  const [showPassword, setShowPassword] = useState(false)
  const { name, label, fullWidth, disabled = false, helperText, type, autoFocus, ...rest } = props

  useEffect(() => {
    if (type === 'password') {
      setIsPassword(true)
    }
  }, [type])

  const handleClickShowPassword = () => setShowPassword(prevState => !prevState)

  const fieldTypeCalculated = isPasswordField ? (showPassword ? 'text' : 'password') : type
  return (
    <Field name={name}>
      {({ field, meta, form }) => {
        return (
          <TextField
            {...field}
            autoFocus={autoFocus}
            type={fieldTypeCalculated}
            fullWidth={fullWidth}
            label={label}
            borderLess
            error={Boolean(meta.touched && meta.error)}
            helperText={(meta.touched && meta.error) || helperText}
            disabled={disabled || form.isSubmitting}
            {...(isPasswordField && {
              InputProps: {
                endAdornment: (
                  <IconButton
                    aria-label="toggle password visibility"
                    tabIndex="-1"
                    onClick={handleClickShowPassword}
                    edge="end"
                    fontSize='small'
                  >
                    {showPassword ? <VisibilityOffOutlinedIcon sx={{ fontSize: '20px', color :'rgba(189, 189, 206, 1)' }} />  : <VisibilityOutlinedIcon sx={{ fontSize: '20px',color:'rgba(189, 189, 206, 1)' }}/>}
                  </IconButton>
                ),
              },
            })}
            {...rest}
          />
        )
      }}
    </Field>
  )
}

export default FormikTextField
